import SearchDrawer from './drawer.vue'
import SearchDrawerItem from './drawer-item'

SearchDrawer.install = Vue => {
  Vue.component(SearchDrawer.name, SearchDrawer)
}

SearchDrawerItem.install = Vue => {
  Vue.component(SearchDrawerItem.name, SearchDrawerItem)
}

export {SearchDrawer, SearchDrawerItem}



// WEBPACK FOOTER //
// ./src/components/search-drawer/index.js